<template>
    <div>
        <div v-if="viewdchartData.length>0 && entitlements.videoVisit === 'Y'">
            <highcharts class="hc" :options="chartOptions"></highcharts>
        </div>
        <div v-else class="text-center p-4 pb-5">
            <span class="proximanova-semibold fontsize14 black" v-if="entitlements.videoVisit === 'Y'">No chart data available between selected dates</span>
            <span class="proximanova-semibold fontsize14 black" v-else>Please Subscribe to any Plan to view the information</span>
        </div>
    </div>
</template>
<script>
import { bus } from "../../main";
import httpuserprofile from '../../js/http-userprofile.js'
export default{
    props : [
      'dateSelectionObject'
    ],
    data(){
        return{
            entitlements : {},
            // selectOptions: ['Last 7 Days','15 Days','30 Days','3 Months','6 Months','12 Months','Custom Range'],
            // selectedStatusCode: 'Last 7 Days',
            // fromDate: '25 may, 2021',
            // toDate: '31 may, 2021',
            viewdchartData: [],
            chartOptions:{
                chart: {
                    type: 'column'
                },
                legend: {
                    enabled:false
                },
                credits: {
                    enabled: false
                },
                colors: ["#007AFF"], 
                title: {
                    text: ''
                },
                xAxis: {
                    gridLineWidth: 1,
                    categories: ['10 Sec', '20 Sec', '30 Sec', '40 Sec', '50 Sec', '60 Sec'],
                    lineColor:'#007AFF',     
                },
                plotOptions: {
                    series: {
                        borderWidth: 1,
                        borderColor: '#007AFF',
                        borderRadius:4,
                        pointWidth: 24,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y}%',  
                             
                            color: 'Gray'             
                        }
                    },
                },
                yAxis: {
                    gridLineWidth: 1,
                    min: 0,
                    max:100,
                    title: {
                        text: ' '
                    },
                    labels: {
                        formatter: function() {
                            return this.value + '%';
                        }
                    }
                },          
                series: [{
                    name: 'Series 1',
                    // data: [30,70,45,20,15,22],         
                    borderRadiusTopLeft: '20px',
                    borderRadiusTopRight: '20px',         
                    color: '#d1e7ff',
                    data : this.viewdchartData
                    // lineColor:'#007AFF',                     
                }]
            },
            initialCall : true,
            profileId : null,
            fromDate : null,
            toDate : null
        }
    },
    mounted(){
        this.entitlements = JSON.parse(localStorage.getItem('entitlements'))
        //bus event to share data from parent component of profile views
        bus.$on("sendDataToVideoViewed", data => {
          console.log("data in videoviews : ", data)
          this.initialCall = false;
          this.profileId = data.profileId,
          this.fromDate = data.fromDate,
          this.toDate = data.toDate;
          this.getChartData()
        });
        //initial call
        this.profileId = this.dateSelectionObject.profileId,
        this.fromDate = this.dateSelectionObject.fromDate,
        this.toDate = this.dateSelectionObject.toDate;
        if(this.initialCall){
            this.getChartData()
        }
        console.log("props obj : ", this.dateSelectionObject)
    },
    watch:{
        viewdchartData(){this.viewdredraw()},
    },
    methods : {
        //fethcing chart data based on selected dates
        getChartData() {
            httpuserprofile.get("/userprofile/videoProfileVisitedChartData?profileId="+this.profileId+"&fromDate="+this.fromDate+"&toDate="+this.toDate)
            .then((response) => {
                console.log(response)
                if(response.data.videoVisistedList === null || response.data.videoVisistedList === undefined){
                    this.viewdchartData = []
                }
                if(response.data.videoVisistedList){
                    this.viewdchartData = response.data.videoVisistedList;
                    console.log(this.viewdchartData)
                    this.viewdredraw()
                }             
            });
        },
        viewdredraw(){   
            var that = this;
            this.chartOptions.series[0].data = this.viewdchartData.map(function (point) {
                return [point.duration + 'Sec' , point.viewedpercent]
            })
            // this.chartOptions.xAxis.categories = []
            // this.chartData.forEach((point) =>{
            //     let x = point.duration
            //     that.chartOptions.xAxis.categories.push(x)
            // });
        },
    },
    beforeDestroy(){
        bus.$off('sendDataToVideoViewed')
    }

}
</script>
<style scoped>
.form-control{
    height: unset !important;
    font-size: 12px;
}
.form-control:focus{
   border: none;
}
.btn-color{
  border-color: #D9DCE1;
  padding: 0px 1px
}
.dropdown-position-bottom.profileStrengthpop {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 150px !important;
    left: unset !important;
    transform: translate3d(-35%,0px,0px);
  }
 .vue-popover.dropdown-position-bottom.profileStrengthpop:before {
    display: none !important;
  }
 .profhoriz {
  margin-top: .25em;
  margin-bottom: .25em;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1);
  opacity:0.4
}
.hc{
    height: 220px;
    width: 100%;
    zoom: 1;
}
</style>
